/*
 * Recipe card videos (snippets/recipe-card.liquid).
 *
 * Cards render <video data-recipe-video data-src="…" poster="…" preload="none" muted loop playsinline>.
 * Only the poster loads with the page. An IntersectionObserver gives a video its src the first
 * time it nears the viewport, plays it while it is on screen and pauses it when it leaves, so
 * at most the handful of visible cards are ever downloading or decoding.
 *
 * Hidden cards (filtered out) never intersect, so they never load. With prefers-reduced-motion
 * the poster stays and nothing autoplays.
 *
 * window.RecipeVideos.observe(root) picks up cards added later.
 */
(function () {
  if (window.RecipeVideos) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var seen = new WeakSet();
  var onScreen = new Set();

  function play(video) {
    if (!video.getAttribute('src') && video.dataset.src) {
      video.src = video.dataset.src;
    }
    video.muted = true;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  var io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                onScreen.add(video);
                play(video);
              } else {
                onScreen.delete(video);
                if (!video.paused) video.pause();
              }
            });
          },
          { rootMargin: '150px 0px', threshold: 0.01 }
        )
      : null;

  function observe(root) {
    if (reduceMotion) return;
    (root || document).querySelectorAll('video[data-recipe-video]').forEach(function (video) {
      if (seen.has(video)) return;
      seen.add(video);
      if (io) io.observe(video);
      else play(video);
    });
  }

  window.RecipeVideos = { observe: observe };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe();
    });
  } else {
    observe();
  }

  // Pause everything while the tab is hidden; resume the on-screen ones on return.
  document.addEventListener('visibilitychange', function () {
    onScreen.forEach(function (v) {
      if (document.hidden) v.pause();
      else if (v.isConnected) play(v);
    });
  });
})();
